export enum ProcessStatus {
    NEW = 'New',
    PENDING = 'Pending',
    INPROGRESS = 'InProgress',
    COMPLETED = 'Completed',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled',
    GENERATED = 'Generated',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
    ERROR = 'Error',
    CLAIMED = 'Claimed',
    // READYTOCLAIM = 'ReadyToClaim',
    ISSUEDTOSUPPLIER = 'IssuedToSupplier',
    JVBOOKED = 'JVBooked',
    CLAIMSETTLED = 'ClaimSettled',
    APMODEL = 'APModel',
}